import { render, staticRenderFns } from "./Sendmail.vue?vue&type=template&id=2e7f55c3&scoped=true&"
import script from "./Sendmail.vue?vue&type=script&lang=js&"
export * from "./Sendmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7f55c3",
  null
  
)

export default component.exports